import { useMemo } from "react";

import useCurrentUser from "../useCurrentUser";

/**
 * Hook that exposes the customer type from the current user.
 */
const useCustomerType = () => {
  const [currentUser, loading, refetch] = useCurrentUser();

  const payload = useMemo(() => [
    currentUser,
    loading,
    refetch,
  ], [
    currentUser,
    loading,
    refetch,
  ]);

  return payload;
};

export default useCustomerType;
